import { config } from 'config';
import io from 'socket.io-client';
const { socketUrl } = config;

export const connectSocket = () => {
    const socket = io(socketUrl);
    socket.on('connect_error', err => {

    });
    return new Promise(resolve => {
        socket.on('connect', () => {
            resolve(socket);
        });
    });
};
